// import '@babel/polyfill'
import Vue from 'vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {
  DropdownPlugin, TablePlugin, BootstrapVue,
  SpinnerPlugin,
  AvatarPlugin,
  ToastPlugin,
  FormPlugin,
} from 'bootstrap-vue';
import Vue2Filters from 'vue2-filters';
import VueMoment from 'vue-moment';
import DashboardPlugin from '@/plugins/dashboard-plugin';
import store from './store';
import router from './routes/router';
import '#/filters/filters';
import '#/project-style.scss'; // This import should be after any shared scss imports
import '#/assets/nucleo/font/css/style.css'; //

// import { getEnv, VUE_APP_STRIPE_ID } from '#/utils/env';
import App from './App.vue';
// Import the Auth0 configuration
import { domain, clientId, audience } from '../auth_config.json';
// Import the Auth0 plugin here
import { Auth0Plugin } from './auth';

Vue.use(AvatarPlugin);
Vue.use(ToastPlugin);
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onAuthStateChange: () => {
    console.log('AUTH CHANGE');
    // getInstance().getIdTokenClaims().then((result) => {
    //   console.log('onAuthStateChange email verification:', result);
    //   if (typeof (result.email_verified) !== 'undefined' && result.email_verified) {
    //     store.commit('setEmailToVerified');
    //   }
    // });

    // store.dispatch(INITIAL_LOAD);
    // store.dispatch(LOAD_ACCOUNT);
  },
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    );
  },
});
Vue.use(BootstrapVue);
Vue.use(Vue2Filters);
Vue.use(VueMoment);
Vue.use(DashboardPlugin);
Vue.use(DropdownPlugin);
Vue.use(TablePlugin);
Vue.use(FormPlugin);
Vue.use(SpinnerPlugin);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
  store,
  router,
});
